import { useRef } from "react";
import { $getNodeByKey, LexicalEditor } from "lexical";
import { uploadImageByUrl } from "../../../core/media.core";
import { $isImageNode } from "../nodes/ImageNode";
import { useQueryClient } from "@tanstack/react-query";

export function useImageRehost(editor: LexicalEditor, scheduleSave: () => void) {
  const processedUrlsRef = useRef<Set<string>>(new Set());
   const queryClient = useQueryClient();

  const rehostImage = async (src: string, nodeKey: string) => {
    if (!src) return;

    const url = new URL(src);
    const isExternal = url.protocol.startsWith("http");

    const whitelist = [
      "s3.ap-east-1.amazonaws.com",
      "s3.af-south-1.amazonaws.com",
    ];

    const isWhitelisted = whitelist.includes(url.hostname);
    
    if (processedUrlsRef.current.has(src)) {
      return;
    }

    if (isExternal && !isWhitelisted) {
      try {

        const media = await uploadImageByUrl(src);
        if(media) {
          const newUrl = media.url;
          processedUrlsRef.current.add(newUrl);
          
          editor.update(() => {
            const node = $getNodeByKey(nodeKey);
            if (node && $isImageNode(node)) {
              node.setSrc(media.url);
            }
          });

          scheduleSave();
          queryClient.invalidateQueries({ queryKey: ["mediaList"] });
        } else {

        }
      } catch (err) {
        console.error("Rehost failed:", err);
      }
    }
  };

  return rehostImage;
}
